import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';

import { ParameterResult } from '@models/swagger';
import { FloorNumberParams } from './service';

export enum FloorNumberActions {
  Failure = '[Catalogs FloorNumber] Failure',
  Request = '[Catalogs FloorNumber] Request',
  Success = '[Catalogs FloorNumber] Success',
}

export const FloorNumberFailure = createAction(FloorNumberActions.Failure, props<{ error: HttpErrorResponse }>());

export const FloorNumberRequest = createAction(FloorNumberActions.Request, props<{ parameters: FloorNumberParams }>());

export const FloorNumberSuccess = createAction(FloorNumberActions.Success, props<{ data: ParameterResult }>());
